import React from 'react';
import LogoImage from '../../../images/claim-up-19.png';

const Header = ({ title, subtitle, showLogo = true }) => {
  return (
    <div className='bg-gradient-to-b from-blue-50 to-white pt-12 pb-6'>
      <div className='max-w-3xl mx-auto px-4'>
        <div className='text-center'>
          {showLogo && <img src={LogoImage} width='160' height='160' alt='ClaimUp' className='mx-auto mb-6' />}
          <h1 className='text-3xl font-bold text-slate-900 mb-3'>{title}</h1>
          <p className='text-lg text-slate-600'>{subtitle}</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
